export default __webpack_public_path__ + "static/media/telaCores.f97020ec.png";